export const L3060D = "last 30-60 days";

export const L30D = "last 30 days";
export const L12M = "last 12 months";
export const N30D = "next 30 days";

export const L30D_ABBR = "L30D";
export const L12M_ABBR = "L12M";
export const N30D_ABBR = "N30D";
